import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

const ProjectCyrenaeus = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: theme.palette.primary.dark,
        background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
        color: theme.palette.common.white,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.75fr" },
          alignItems: "center",
          maxWidth: 1180,
          mx: "auto",
          px: { xs: 2, sm: 4 },
          py: { xs: 7, md: 10 },
          gap: { xs: 4, md: 7 },
        }}
      >
        <Box
          sx={{
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Chip
            label="About the charity"
            sx={{
              bgcolor: "rgba(255,255,255,0.1)",
              color: theme.palette.common.white,
              border: "1px solid rgba(255,255,255,0.2)",
              mb: 2,
              mx: { xs: "auto", md: 0 },
              display: "inline-flex",
            }}
          />
          <Typography
            variant="h2"
          component="h1"
            sx={{
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontStyle: "italic",
              fontWeight: 500,
              fontSize: { xs: "2.5rem", md: "4rem" },
              lineHeight: 1.05,
            }}
          >
            Project Cyrenaeus
          </Typography>
          <Typography
            sx={{
              mt: 2,
              color: "rgba(255,255,255,0.84)",
              lineHeight: 1.8,
              fontSize: { xs: "1rem", md: "1.08rem" },
            }}
          >
            Cyrenaeus creates sustainable links between reconstructive surgical
            partners in Europe and surgical teams in low and middle-income
            countries. Our current project connects UK West-based plastic
            surgery teams with St. Mary's Lacor Hospital in Northern Uganda.
          </Typography>
        </Box>
        <Box
          sx={{
            justifySelf: "center",
            width: "min(100%, 310px)",
            aspectRatio: "9 / 16",
            borderRadius: 2,
            overflow: "hidden",
            border: "1px solid rgba(255,255,255,0.22)",
            boxShadow: "0 24px 70px rgba(0,0,0,0.24)",
          }}
        >
          <iframe
            src="https://player.vimeo.com/video/1121455070?badge=0&autopause=0&player_id=0&app_id=58479"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Project Cyrenaeus"
            loading="lazy"
            style={{ width: "100%", height: "100%", border: 0 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectCyrenaeus;
